import { styled } from '@mui/material/styles';
import { ReactNode } from 'react';

interface SvgWrapperProps {
  children: ReactNode;
  bgColor?: string;
  padding?: number;
}

const SvgContainer = styled('div')<{
  $bgColor?: string;
  $padding?: number;
}>(({ $bgColor = '#ffffff', $padding = 2 }) => ({
  position: 'relative',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: $bgColor,
  padding: $padding,
  borderRadius: '50%',
  
  '& svg': {
    position: 'relative',
    zIndex: 1,
    display: 'block'
  },
  
  '& path': {
    position: 'relative',
    zIndex: 2
  }
}));

export const SvgBackgroundWrapper = ({ 
  children, 
  bgColor = '#ffffff',
  padding = 2
}: SvgWrapperProps) => {
  return (
    <SvgContainer $bgColor={bgColor} $padding={padding}>
      {children}
    </SvgContainer>
  );
};

// Usage:
// <SvgBackgroundWrapper bgColor="#ffffff" padding={4}>
//   <YourSvgIcon />
// </SvgBackgroundWrapper>